function u(e, ...r) {
  return r.reduce((t, n) => n(t), e);
}
export {
  u as t
};
